import { getQueryParam } from './get-query-param';

export function getIsNewMobileLandscape() {
  const isNewMobileLandscape = getQueryParam('allowMobileLandscape');
  return isNewMobileLandscape === 'true';
}
